import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { ArrowRight } from 'lucide-react';
import { Loader } from './ui/loader';

export function PreviousAnalyses({ analyses, isLoading }) {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  if (isLoading) return <Loader />;
  if (!analyses?.length) return null;

  return (
    <div className="max-w-2xl gap-8 mb-20 mx-auto">
      <h2 className="text-3xl font-bold text-center mb-12 text-white">Previous Analyses</h2>
      <div className="flex flex-col gap-4">
        {analyses.map(analysis => (
          <Card 
            key={analysis.id} 
            className="bg-[#1A1A1A] border-[#333] hover:bg-[#222] transition-all duration-300 cursor-pointer group"
            onClick={() => navigate(`/analysis/${analysis.id}`)}
          >
            <CardContent className="p-6 flex items-center justify-between">
              <div className="flex-1">
                <p className="text-orange-500 hover:text-orange-400 font-medium mb-2 break-all">
                  {analysis.url}
                </p>
                <p className="text-sm text-zinc-400">
                  {formatDate(analysis.timestamp)}
                </p>
              </div>
              <ArrowRight className="w-5 h-5 text-orange-500 group-hover:text-orange-400 group-hover:translate-x-1 transition-all" />
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
} 